<template>
  <div class="split" v-if="data">
    <div class="inner"></div>
  </div>
</template>
<script>
export default {
  name: "split",
  data() {
    return {};
  },
  inject: {
    $customDropTree: {
      default: null
    }
  },
  props: {
    data: {
      type: Object,
      default() {
        return null;
      }
    },
    pos: {
      type: String,
      default: ""
    }
  },
  mounted() {
    if(!this.$customDropTree.isReadOnly){
      this.initDrop();
    }
  },
  methods: {
    initDrop() {
      let _this = this;
      $(this.$el).droppable({
        accept: _this.$customDropTree.acceptDrag,
        greedy: true,
        tolerance: "pointer",
        hoverClass: "split-hover",
        drop($evt, ui) {
          if (_this.pos) {
            let fromData;
            if (_this.$customDropTree.dragStart) {
              //组件内部节点互相拖动
              fromData = ui.draggable.get(0).__vue__.data;
            } else {
              //与外部节点拖动
              let data = _this.$customDropTree.dragData(ui);
              if(dsf.isEmptyObject(data)){
                return false;
              }
              fromData = _this.$customDropTree.setDataReal(data);
            }
            _this.dropToSplit(fromData, _this.data, _this.pos);
          }
          _this.$customDropTree.dragStart = false;
        }
      });
    },
    dropToSplit(fromData, target, pos) {
      let oldItems = fromData?.parent?.items;
      if (oldItems) {
        dsf.array.remove(oldItems, fromData);
      }
      let items = target?.parent?.items;
      let index = _.findIndex(items, (it) => {
        return it == target;
      });
      if (index >= 0) {
        if (pos == "after") {
          index++;
        }
        items.splice(index, 0, fromData);
      }
      this.$customDropTree.resetTree();
    }
  }
};
</script>